(function () {
  var sections = document.querySelectorAll('.tw-mini-banner-section');

  sections.forEach(function (section) {
    var list = section.querySelector('.mini-banner-list');
    var dots = section.querySelectorAll('.mini-banner-dots .dot');
    var items = section.querySelectorAll('.mini-banner-list__item');

    if (!list || !dots.length || !items.length) return;

    var scrollTimeout;
    list.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var scrollLeft = list.scrollLeft;
        var gap = parseFloat(getComputedStyle(list).gap) || 8;
        var itemWidth = items[0].offsetWidth;
        var activeIndex = Math.round(scrollLeft / (itemWidth + gap));

        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === activeIndex);
        });
      }, 50);
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index);
        var gap = parseFloat(getComputedStyle(list).gap) || 8;
        var itemWidth = items[0].offsetWidth;
        list.scrollTo({
          left: index * (itemWidth + gap),
          behavior: 'smooth',
        });
      });
    });
  });
})();
